import * as actionTypes from "../constants/contactContants";

export const contactReducers = (contact = [], action) => {
  switch (action.type) {
    case actionTypes.SUBMITCONTACT:
      return [...contact, action.payload];
    default:
      return contact;
  }
};
